import React, {useEffect} from 'react';
import Chat from './Chat';
import Laptop from './img/laptop.svg';
import DevBox from './Components/DevBox';
import DevInfo from './Components/DevInfo';
import InfoImg from './img/tutoring1.svg';
import InfoImg1 from './img/tutoring2.svg';
import InfoImg2 from './img/tutoring3.svg';
import Aos from 'aos';
import "aos/dist/aos.css";

function Tutoring() {
    
       
    useEffect(() => {
        Aos.init({ duration: 700,
            delay:200});
    }, [])

    return (
        <div className="websites">
            <div className="website-hero-bg"/>      
            <div className="website-hero-white"/>      
            <div className="website-hero" data-aos="fade-up">
                <div className="website-hero-text">
                    <h1>TUTORING</h1>
                    <h3>From £20/hr*</h3>
                </div>
                <img src={Laptop}/>
            </div>
            
            
            <div className="website-benifits">
                <DevBox title="Qaulity Guarentee" text="We're that confident that you'll be happy with our work."/>
                <DevBox title="Flexible planning" text="Plan us whenever convenient to you, we work around your schedule."/>
                <DevBox title="Expert Tutors" text="All of our tutors have 4+ years of experience and are qualified in a computing degree."/>
            </div>

            <div className="website-info">

                <DevInfo direction="devinfo-left"
                 img={InfoImg} SCALABLE
                 title="EARN VALIDATED CERTIFICATES"
                 text="Benifit from revieving both experience and validated certificates which you can use to display on your cv or in a job application. " />

                <DevInfo direction="devinfo-right"
                 img={InfoImg1}
                title="GAIN INDUSTRY GRADE KNOWLEDGE"
                 text="Working along side full time software developers will give you an insight into how to produce clean, concise and efficient code along with industry tips and tricks on organisation, architecture and design patterns." />


                <DevInfo direction="devinfo-left"
                 img={InfoImg2} SCALABLE
                 title="SINGLE LESSONS & PACKAGES"
                 text="Buying lessons is flexible, either purchase lesson-to-lesson or benifit from a structured & catered tutoring plan along with a discounted hourly rate when buying lessons in bulk. " />
            </div>
            
            
            <Chat/>
        </div>
    )
}

export default Tutoring
